module.exports = __webpack_public_path__ + "static/hunt1-0688389c3f227de498f4bd6cc856326b.jpg";